module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="tree"></div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/medicals/snomed-tree.html
// module id = 352
// module chunks = 0